import React from 'react';

import { Link, Text, VStack } from '@/components';
import { useTranslation } from '@/hooks';
import { footerLinks } from '@/statics';

const ContactLia: React.FC = () => {
  const { t } = useTranslation('components.footer.contactLia');

  return (
    <>
      <VStack alignItems={'start'} gap={0}>
        <Text color="text" fontWeight="bold" fontSize={'lg'}>
          {t('contactLia')}
        </Text>
        <VStack alignItems={'start'} spacing={'20px'} mt={'30px'}>
          {footerLinks.StaticsDataContactLia.map((data, index: number) => (
            <Link key={index} href={data.url}>
              <Text color="text" fontWeight="medium" fontSize={'sm'}>
                {data.title}
              </Text>
            </Link>
          ))}
        </VStack>
      </VStack>
    </>
  );
};

export default ContactLia;
